// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge_3aUbC","disabled":"Badge_disabled_JosBs"};
    if(module.hot) {
      // 1789136764128
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  